<template>
    <div class="column is-one-third-touch is-centered is-horizontal-center is-narrow-desktop">
        <figure class="image is-96x96 has-text-centered" @click="addAuctionToQuery(auction.id)">
            <img :src="'/static/images/auctions/' + auction.name + '.png'" @error="getDefaultImgSource">
            <span>{{ auction.name }} <input type="checkbox" v-model="isActive" /></span>
        </figure>
    </div>
</template>
<script>
    export default {
        props: ['auction'],
        methods: {
            getDefaultImgSource(element) {
                element.target.src = '/static/images/logo.png'
            },
            addAuctionToQuery: function (auctionId) {
                if ( this.$store.getters.getQueryAuctionById(auctionId).length === 0 ) {
                    this.$store.dispatch('addAuctionToQuery', auctionId)
                } else {
                    this.$store.dispatch('removeAuctionFromQuery', auctionId)
                }
            }
        },
        computed: {
            isActive: {
                get: function () {
                    return this.$store.getters.getQueryAuctionById(this.auction.id).length !== 0
                },
                set: function (value) {

                }
            }
        }
    }
</script>

<style scoped>
    .is-horizontal-center {
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Locations/LocationImage.vue